{
	"transactionCardHeader": "Bekreft en transaksjon",
	"transactionCardDescriptionBold": "Vil du validere en transaksjon for et hvilket som helst prosjekt?",
	"transactionCardDescriptionRegular": "Hvis du har et transaksjonsnummer for hånden, kan du angi det her og validere transaksjonen.",
	"showTransactionButton": "Vis transaksjonen",
	"transactionLabel": "Transaksjonsnummer",
	"errors": {
		"transactionIdRequired": "Transaksjonsnummer er påkrevd.",
		"transactionNotFound": "Ingen transaksjon funnet.",
		"transactionIdInvalid": "Ugyldig transaksjonsnummer."
	}
}
